import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AboutGameScore from "../AboutGameScore/AboutGameScore";

const style = {
	position: "relative",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "50%",
	height: "90%",
	overflow: "scroll",
	bgcolor: "background.paper",
	borderRadius: "10px",
	paddingLeft: 5,
	paddingRight: 5,
};

export default function AboutGameScoreModal(props) {
	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				open={props.isOpen}
				onClose={props.isClose}
				closeAfterTransition
				sx={{ zIndex: "1506" }}>
				<Fade in={props.isOpen}>
					<Box sx={style}>
						<AboutGameScore />
					</Box>
				</Fade>
			</Modal>
		</div>
	);
}
